import { createSelector } from 'reselect'

import { userCredentialsSelector } from 'redux/selectors/user'

const interactiveVideoData = state => state.interactiveVideoCreation

const identitySelector = createSelector(
	[ interactiveVideoData, userCredentialsSelector ],
	(interactiveVideo, userCredentials) => ({
		jwt: userCredentials.interactiveVideo,
		uid: interactiveVideo.uid,
		externalUid: interactiveVideo.externalUid,
		presentationUid: interactiveVideo.presentationUid,
	})
)

export default identitySelector
